export default __webpack_public_path__ + "static/media/image-glass-and-keyboard.85d2dcc3.jpg";